import { useEffect, useState } from "react";
import axios from "axios";

export default function ListStudentSelectorModal({ onClose, onEnroll }) {

  const API_BASE = "https://api.ilogically.com/api";
  const APP_TOKEN = "87adfacc2dffc65ae172d59a9f0badda";

  const [lists, setLists] = useState([]);
  const [selectedList, setSelectedList] = useState(null);

  const [students, setStudents] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);

  // fetch lists
  const fetchLists = async () => {

    const res = await axios.get(
      `${API_BASE}/users/lists`,
      { params: { appToken: APP_TOKEN } }
    );

    setLists(res.data);
  };

  useEffect(() => {
    fetchLists();
  }, []);

  // fetch members
  const fetchMembers = async (listId) => {

    const res = await axios.get(
      `${API_BASE}/users/lists/${listId}/members`,
      { params: { appToken: APP_TOKEN } }
    );

    setStudents(res.data);
    setSelectedStudents([]);
  };

  const selectList = (list) => {
    setSelectedList(list);
    fetchMembers(list.id);
  };

  const toggleStudent = (id) => {

    setSelectedStudents(prev => {

      if (prev.includes(id)) {
        return prev.filter(s => s !== id);
      }

      return [...prev, id];

    });

  };

  const selectAll = () => {
    setSelectedStudents(students.map(s => s.ID));
  };

  const clearAll = () => {
    setSelectedStudents([]);
  };

  const handleEnroll = () => {
    onEnroll(selectedStudents);
  };

  return (
    <div style={{
      position: "fixed",
      top: 50,
      left: "10%",
      width: "80%",
      background: "#fff",
      border: "1px solid #ccc",
      padding: 20
    }}>

      <h2>Select Students From List</h2>

      <div style={{ display: "flex", gap: 30 }}>

        {/* LISTS PANEL */}

        <div style={{ width: "30%" }}>

          <h3>Lists</h3>

          {lists.map(list => (

            <div
              key={list.id}
              style={{
                padding: 8,
                borderBottom: "1px solid #eee",
                cursor: "pointer",
                background:
                  selectedList?.id === list.id
                    ? "#f5f5f5"
                    : "white"
              }}
              onClick={() => selectList(list)}
            >

              <strong>{list.name}</strong>
              <div style={{ fontSize: 12 }}>
                {list.membersCount} members
              </div>

            </div>

          ))}

        </div>

        {/* STUDENTS PANEL */}

        <div style={{ width: "70%" }}>

          {selectedList && (
            <>
              <h3>
                Students in "{selectedList.name}"
              </h3>

              <button onClick={selectAll}>
                Select All
              </button>

              <button
                style={{ marginLeft: 10 }}
                onClick={clearAll}
              >
                Clear
              </button>

              <div style={{ marginTop: 15 }}>

                {students.map(student => (

                  <div key={student.ID}>

                    <input
                      type="checkbox"
                      checked={selectedStudents.includes(student.ID)}
                      onChange={() => toggleStudent(student.ID)}
                    />

                    {student.firstName} {student.lastName}
                    {" - "}
                    {student.userEmail}

                  </div>

                ))}

              </div>
            </>
          )}

        </div>

      </div>

      <div style={{ marginTop: 20 }}>

        <button onClick={handleEnroll}>
          Enroll Selected ({selectedStudents.length})
        </button>

        <button
          style={{ marginLeft: 10 }}
          onClick={onClose}
        >
          Close
        </button>

      </div>

    </div>
  );
}